import state from './sessions.state'
import mutations from './sessions.mutations'
import actions from './sessions.actions'
import getters from './sessions.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
